import * as React from 'react';
import { backdropClasses, Paper, Typography } from "@mui/material";
import Zoom from '@mui/material/Zoom';
import styles from '../css/rdTrf.module.css';

export const VmsDisplayBox = ({ item }) => {
    const [transitionIn, setTransitionIn] = React.useState(false)

    React.useEffect(() => {
        setTransitionIn(false)
        const key = setTimeout(() => {  
            setTransitionIn(true)
        }, 400);

        return () => clearTimeout(key)
    }, [item])

    return (
        <Zoom in={transitionIn} timeout={300} easing={{ enter: "ease-out", exit: "ease-in" }} 
        sx={{
            display:'flex',
            alignItems: 'center',
            flexDirection: 'column',
            justifyContent: 'center',
            bgcolor: '#1B2138',
            backgroundImage:'none',
            p:0,
            borderRadius:'10px',
            }}
        >
            <Paper elevation={3} sx={{}}>
                <Typography variant='h6' sx={{pb:1, pt:1}}>{item.name}</Typography>
                <img alt='img' style={{
                    minHeight:'60px',
                    maxHeight:'200px',
                    display: 'block'
                }} 
                //src={`/api/dashboard/VmsImage?vmsId=${item.id}`} 
                src={`data:image/png;base64,${item.dspBytes}`}
                />
            </Paper>
        </Zoom>
    )
}